<script setup lang="ts">
	import {msg} from "@/i18n/Message";
	import {ref, computed} from 'vue';
	import ErrorMsg from "./ErrorMsg.vue";
	import { useBaseStep } from './BaseStep';
	import SymIcon from "@fd/helpers/SymIcon.vue";
	import ProgressButton from "./ProgressButton.vue";
	

	const emit = defineEmits(['nextStep','updateForm']);
	const props = defineProps({
		form: Object,
		restApi: String,
		endPoint: { type: String, default: "/folders" }
	});
	const { errorMessage, isError, progress, submitOnEnter,
			sendForm, nextStep, 
			errEmptyStringClass  } = useBaseStep(props,emit,validateForm);
		

	function validateForm(): boolean {
		if (!Boolean(props.form.pathFulltext)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		if (!Boolean(props.form.pathMail)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		if (!Boolean(props.form.pathOther)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		if (!Boolean(props.form.pathMount)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		if (!Boolean(props.form.pathSpam)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		return true;
	}
	
	function refill(): void {
		var fulltextValue = props.form.pathFulltext;
		if (fulltextValue.includes("/") || fulltextValue.includes("\\")) {
			var theSeparator = fulltextValue.includes("/")?'/':'\\';
			var subPath = fulltextValue.substring(0, fulltextValue.lastIndexOf(theSeparator)+1);
			
			if (!Boolean(props.form.pathMail)) emit('updateForm', 'pathMail', subPath.concat('mail'));
			if (!Boolean(props.form.pathOther)) emit('updateForm', 'pathOther', subPath.concat('other'));
			if (!Boolean(props.form.pathMount)) emit('updateForm', 'pathMount', subPath.concat('shared'));
			if (!Boolean(props.form.pathSpam)) emit('updateForm', 'pathSpam', subPath.concat('spam'));
		}
	}
	
	function reset() {
		emit('updateForm', 'pathFulltext', "");
		emit('updateForm', 'pathMail', "");
		emit('updateForm', 'pathOther', "");
		emit('updateForm', 'pathMount', "");
		emit('updateForm', 'pathSpam', "");
	}
	
	function onSubmit(): void {
		sendForm(props.form,'Application');
	}
</script>
<template>
	<div>
	<div class="formTitle">{{msg("install.title.folders")}}</div>
	<form @submit.prevent>
	<table border="0" cellspacing="0" class="formTable">
		<tr>
			<th>{{msg("install.path.fulltext")}}:</th>
			<td style="white-space: nowrap;"><input type="text" :value="form.pathFulltext" size="32" @blur="refill" tabindex="10" @keypress="submitOnEnter($event,onSubmit)"
					@input="$emit('updateForm', 'pathFulltext', $event.target.value)" :class="errEmptyStringClass(form.pathFulltext)">
				&nbsp;<a @click.prevent="reset();" href="#" :title="msg('install.path.clear')" ><sym-icon name="cross-circle-18"/></a>
			</td>
		</tr>
		<tr>
			<th>{{msg("install.path.email")}}:</th>
			<td><input type="text" :value="form.pathMail" size="32" tabindex="20" @keypress="submitOnEnter($event,onSubmit)"
					@input="$emit('updateForm', 'pathMail', $event.target.value)" :class="errEmptyStringClass(form.pathMail)"></td>
		</tr>
		<tr>
			<th>{{msg("install.path.other")}}:</th>
			<td><input type="text" :value="form.pathOther" size="32" tabindex="30" @keypress="submitOnEnter($event,onSubmit)"
					@input="$emit('updateForm', 'pathOther', $event.target.value)" :class="errEmptyStringClass(form.pathOther)"></td>
		</tr>
		<tr>
			<th>{{msg("install.path.mount")}}:</th>
			<td><input type="text" :value="form.pathMount" size="32" tabindex="40" @keypress="submitOnEnter($event,onSubmit)"
					@input="$emit('updateForm', 'pathMount', $event.target.value)" :class="errEmptyStringClass(form.pathMount)"></td>
		</tr>
		<tr>
			<th>{{msg("install.path.spam")}}:</th>
			<td><input type="text" :value="form.pathSpam" size="32" tabindex="50" @keypress="submitOnEnter($event,onSubmit)"
					@input="$emit('updateForm', 'pathSpam', $event.target.value)" :class="errEmptyStringClass(form.pathSpam)"></td>
		</tr>
		<tr>
			<th>&nbsp;</th>
			<td>
				<label><input type="checkbox" :checked="form.forceCreate" tabindex="60"
						@input="$emit('updateForm', 'forceCreate', $event.target.checked)" /> {{msg("install.path.forceCreate")}}</label>
			</td>
		</tr>
		<tr>
			<td colspan="2"><error-msg :show="isError" :msg="errorMessage"/></td>
		</tr>
		<tr>
			<td style="padding-top:10px" colspan="2">
				<button @click="nextStep('Database')" class="sbutton">
					<sym-icon name="page-prev-16-full" style="padding-right: 10px;"/>{{msg("install.butt.back")}}
				</button>
				&nbsp;
				<progress-button @click="onSubmit" :progress="progress"
					class="button" icon="page-next-16-full">
					{{msg('install.butt.next')}}
				</progress-button>
			</td>
		</tr>
	</table>
	</form>
	</div>
</template>
